import React from 'react';
import ReactDom from 'react-dom';
import { motion } from 'framer-motion';
import BackButton from './elements/BackButton';

export default function TestModal({ open, children, onClose }) {
  const MODAL_STYLES = {
    position: 'fixed',
    top: '18px',
    left: '21px',
    backgroundColor: '#03091a',
    padding: '50px',
    zIndex: 8500,
    width: '985px',
    height: '661px',
    borderRadius: '15px',
    overflow: 'hidden',
  };

  const OVERLAY_STYLES = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, .9)',
    zIndex: 8000,
  };

  const BACK_STYLES = {
    cursor: 'pointer',
    zIndex: 8000,
    position: 'relative',
  };
  if (!open) return null;

  return ReactDom.createPortal(
    <>
      <div style={OVERLAY_STYLES} />
      <motion.div
        style={MODAL_STYLES}
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <BackButton close={onClose} style={BACK_STYLES} />

        {children}
      </motion.div>
    </>,
    document.getElementById('portal')
  );
}
